import { Box, IconButton, styled } from "@mui/material";





export const ForPartnersBoxStyle = styled(Box, { shouldForwardProp: (prop) => prop !== "background" })<{ background?: string; }>(({ theme, background }) => ({
    background: background,

    [theme.breakpoints.only('xl')]: {
        width: "644px",
        height: "217px",
        borderRadius: "30px",
        padding: "31px 82px 0px 40px",
    },
    [theme.breakpoints.only('lg')]: {
        width: "644px",
        height: "217px",
        borderRadius: "30px",
        padding: "31px 82px 0px 40px",
    },
    [theme.breakpoints.only('md')]: {
        width: "365px",
        height: "136px",
        borderRadius: "20px",
        padding: "19px 16px 0px 26px",
    },
    [theme.breakpoints.down('md')]: {
        width: "364px",
        height: "136px",
        borderRadius: "20px",
        padding: "19px 16px 0px 26px",
    },
    position: "relative",
    cursor: "pointer"
}));

export const ForPartnersIconButtonStyle = styled(IconButton, { shouldForwardProp: (prop) => prop !== "customColor" })<{ customColor?: string; }>(({ theme, customColor }) => ({
    color: customColor,
    position: "absolute",
    [theme.breakpoints.only('xl')]: {
        width: "48px", height: "48px",
        right: "24px", bottom: "20px",
        border: `3px solid ${customColor}`,
    },
    [theme.breakpoints.only('lg')]: {
        width: "48px", height: "48px",
        right: "24px", bottom: "20px",
        border: `3px solid ${customColor}`,
    },
    [theme.breakpoints.only('md')]: {
        width: "32px", height: "32px",
        right: "20px", bottom: "20px",
        border: `3px solid ${customColor}`,
    },
    [theme.breakpoints.down('md')]: {
        width: "24px", height: "24px",
        right: "15px", bottom: "15px",
        border: `2px solid ${customColor}`,
    },

    padding: "0px"
}));